// extracted by mini-css-extract-plugin
module.exports = {"root":"IntervalSetupList_root__FISMz"};